import React, { createContext, useContext, useEffect, useState } from "react";

const I18nContext = createContext(null);

const dict = {
  nl: {
    nav: {
      home: "Home",
      classics: "Klassiekers",
      rooms: "Ruimtes",
      approach: "Hoe wij werken",
      contact: "Contact",
    },
    tagline: "Tijdloze vorm. Perfecte ruimte.",
    common: {
      readMore: "Meer lezen",
      backTo: "Terug naar",
      classics: "klassiekers",
      rooms: "ruimtes",
      designer: "Ontwerper",
      brand: "Producent",
      year: "Jaar",
      category: "Categorie",
      filters: "Filters",
      all: "Alle",
      results: "resultaten",
      result: "resultaat",
      clearAll: "Wis filters",
      related: "Gerelateerde stukken",
      featuredIn: "Geselecteerd voor",
      inquire: "Vraag aan",
      learnMore: "Ontdek meer",
      cta: "Vertel ons over uw project",
      none: "Geen resultaten",
      view: "Bekijk",
    },
    categories: {
      stoel: "Stoelen",
      loungefauteuil: "Loungefauteuils",
      verlichting: "Verlichting",
      tafel: "Tafels",
      bank: "Banken",
    },
    home: {
      eyebrow: "Onafhankelijk Nederlands designadvies",
      heroCta: "Start een gesprek",
      heroSecondary: "Verken de collectie",
      approachTitle: "Onze aanpak",
      approachIntro: "Geen showroom. Geen catalogus. Een gesprek, een uitgekiende selectie, en een ruimte die jarenlang werkt.",
      steps: [
        { t: "Intake", b: "We luisteren. We bezoeken de ruimte, leren het gebruik kennen, kalibreren het budget." },
        { t: "Advies & Curation", b: "Een korte, beargumenteerde shortlist uit twee eeuwen ontwerpgeschiedenis — geen merken pushen." },
        { t: "Levering & Styling", b: "Inkoop, logistiek, plaatsing. We laten de ruimte achter zoals u hem voor zich zag." },
      ],
      featuredTitle: "Geselecteerde klassiekers",
      featuredSubtitle: "Stukken waar we keer op keer naar terugkeren.",
      roomsTitle: "Ruimtes",
      roomsSubtitle: "Waar het werk landt — van advocatenkantoor tot leeskamer.",
      projectsTitle: "Recente projecten",
      projectsSubtitle: "Vertrouwd door studio's, kantoren en particulieren — anoniem op verzoek.",
      ctaSection: "Een ruimte in gedachten?",
      ctaSection2: "Stuur een korte briefing. We antwoorden persoonlijk.",
    },
    classics: {
      title: "Klassiekers",
      subtitle: "Een doorlopend bijgehouden archief van ontwerpen die de tijd doorstaan — gemeubileerd met de zorg van een galerie.",
      activeFilters: "Actieve filters",
      noResults: "Geen klassiekers gevonden met deze filters.",
    },
    rooms: {
      title: "Ruimtes",
      subtitle: "Vijf werelden waarin onze selecties tot rust komen. Elke ruimte vraagt om een ander gebaar.",
    },
    approach: {
      title: "Hoe wij werken",
      subtitle: "Een tastbaar proces, gedragen door één persoon. Geen accountmanagers, geen tussenpartijen.",
      stepsTitle: "Het proces, in vijf stappen",
      audienceTitle: "Voor wie werken wij?",
      audienceIntro: "Cliënten die het verschil zien tussen volgen en kiezen.",
      audience: [
        { t: "Designstudio's", b: "Bureaus die hun werkruimte gebruiken als visitekaartje voor opdrachtgevers." },
        { t: "Architecten", b: "Partners die hun project niet willen aankleden met catalogusoplossingen." },
        { t: "Particulieren", b: "Bewoners die hun huis bouwen rondom een paar stukken voor het leven." },
        { t: "Advocaten- & adviesbureaus", b: "Vertegenwoordiging die verzekerd, niet uitgestald wil overkomen — één voorbeeld van professionals die wij begeleiden." },
      ],
      aboutTitle: "Over ons",
      aboutText: "DeStoel.com is een Nederlandse studio voor interieuradvies en designcuratie, sinds 2001. Wij werken bijvoorbeeld voor architectenbureaus, designstudio's, advocatenkantoren en particuliere opdrachtgevers met smaak — bij het samenstellen van ruimtes met iconisch 20e-eeuws meubilair en verlichting. Onze rol: luisteren, cureren, en met zorg leveren.",
      processSteps: [
        { t: "Eerste gesprek", b: "Vrijblijvend. Telefonisch of op locatie. We bepalen of er een match is voor we verder gaan." },
        { t: "Plaatsbezoek & briefing", b: "We meten op, kijken naar licht, gebruik, akoestiek. We luisteren naar wat de ruimte nu niet doet." },
        { t: "Curation & voorstel", b: "Een schriftelijk voorstel met een korte shortlist, motivering per keuze, en een transparant budget." },
        { t: "Inkoop & bewerking", b: "Wij bestellen rechtstreeks bij producent of geverifieerde herkomst. Reparatie en herstoffering waar zinvol." },
        { t: "Plaatsing & nazorg", b: "Levering, plaatsing, fotodocumentatie. Een onderhoudsplan voor de jaren erna." },
      ],
    },
    contact: {
      title: "Contact",
      intro: "Voor projectaanvragen, samenwerking, of een eerste gesprek — schrijf ons direct. We antwoorden binnen twee werkdagen.",
      general: "Algemeen",
      mailtoSubject: "Projectaanvraag DeStoel.com",
    },
    footer: {
      rights: "Alle rechten voorbehouden",
      contact: "Contact",
      navigate: "Navigatie",
      brand: "DeStoel.com",
      domain: "destoel.com",
    },
  },
  en: {
    nav: {
      home: "Home",
      classics: "Classics",
      rooms: "Rooms",
      approach: "How we work",
      contact: "Contact",
    },
    tagline: "Timeless form. Perfect space.",
    common: {
      readMore: "Read more",
      backTo: "Back to",
      classics: "classics",
      rooms: "rooms",
      designer: "Designer",
      brand: "Maker",
      year: "Year",
      category: "Category",
      filters: "Filters",
      all: "All",
      results: "results",
      result: "result",
      clearAll: "Clear filters",
      related: "Related pieces",
      featuredIn: "Selected for",
      inquire: "Inquire",
      learnMore: "Learn more",
      cta: "Tell us about your project",
      none: "No results",
      view: "View",
    },
    categories: {
      stoel: "Chairs",
      loungefauteuil: "Lounge",
      verlichting: "Lighting",
      tafel: "Tables",
      bank: "Sofas",
    },
    home: {
      eyebrow: "Independent Dutch design advisory",
      heroCta: "Start a conversation",
      heroSecondary: "Explore the archive",
      approachTitle: "Our approach",
      approachIntro: "No showroom. No catalogue. A conversation, a considered selection, and a space that holds for years.",
      steps: [
        { t: "Intake", b: "We listen. We visit the space, learn how it's used, calibrate the budget." },
        { t: "Advice & Curation", b: "A short, argued shortlist drawn from two centuries of design — never brand-led." },
        { t: "Delivery & Styling", b: "Procurement, logistics, placement. We leave the space as you pictured it." },
      ],
      featuredTitle: "Selected classics",
      featuredSubtitle: "Pieces we return to again and again.",
      roomsTitle: "Rooms",
      roomsSubtitle: "Where the work lands — from law firm to reading room.",
      projectsTitle: "Recent projects",
      projectsSubtitle: "Trusted by studios, firms and private clients — anonymous on request.",
      ctaSection: "A space in mind?",
      ctaSection2: "Send a short brief. We reply personally.",
    },
    classics: {
      title: "Classics",
      subtitle: "A living archive of designs that outlast trends — furnished with the care of a gallery.",
      activeFilters: "Active filters",
      noResults: "No classics match these filters.",
    },
    rooms: {
      title: "Rooms",
      subtitle: "Five worlds in which our selections come to rest. Each room asks for a different gesture.",
    },
    approach: {
      title: "How we work",
      subtitle: "A tangible process, carried by one person. No account managers, no middlemen.",
      stepsTitle: "The process, in five steps",
      audienceTitle: "Who do we work with?",
      audienceIntro: "Clients who see the difference between following and choosing.",
      audience: [
        { t: "Design studios", b: "Practices using their own workspace as a calling card for clients." },
        { t: "Architects", b: "Partners who refuse to finish their projects with off-the-shelf furniture." },
        { t: "Private clients", b: "Homeowners building a house around a few pieces meant for life." },
        { t: "Law & advisory firms", b: "Representation that wants to read as assured — one example among the kinds of professionals we work with." },
      ],
      aboutTitle: "About us",
      aboutText: "DeStoel.com is a Dutch studio for interior advice and design curation, since 2001. We work, for example, with architecture practices, design studios, law firms, and private clients with taste — composing spaces around iconic 20th-century furniture and lighting. Our role: listen, curate, deliver with care.",
      processSteps: [
        { t: "First conversation", b: "Obligation-free. By phone or on site. We decide together whether there's a fit before we go further." },
        { t: "Site visit & brief", b: "We measure, study light, use, acoustics. We listen to what the space isn't doing yet." },
        { t: "Curation & proposal", b: "A written proposal with a tight shortlist, reasoning per choice, and a transparent budget." },
        { t: "Procurement & restoration", b: "We buy direct from maker or verified provenance. Repair and reupholstery where it makes sense." },
        { t: "Placement & aftercare", b: "Delivery, installation, photo documentation. A care plan for the years that follow." },
      ],
    },
    contact: {
      title: "Contact",
      intro: "For project enquiries, collaborations, or a first conversation — write directly. We reply within two business days.",
      general: "General",
      mailtoSubject: "Project enquiry DeStoel.com",
    },
    footer: {
      rights: "All rights reserved",
      contact: "Contact",
      navigate: "Navigate",
      brand: "DeStoel.com",
      domain: "destoel.com",
    },
  },
};

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const stored = localStorage.getItem("destoel_lang");
      return stored === "en" ? "en" : "nl";
    } catch {
      return "nl";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("destoel_lang", lang);
      document.documentElement.lang = lang;
    } catch (_e) {
      /* localStorage unavailable */
    }
  }, [lang]);

  const t = dict[lang];

  const value = { lang, setLang, t };
  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used inside I18nProvider");
  return ctx;
}
